ApiPromise = undefined
queueRequire -> ApiPromise = require 'network/api-promise'
React = require 'react'
t = require('views/internal/recup-with-helpers')('manage_members')

module.exports = class extends React.Component
  displayName: 'InvitationLink'

  constructor: (props) ->
    super(props)

    @state = {
      linkEnabled: false
      invitationUrl: ''
    }

  render: t.renderable ->
    { invitationUrl, linkEnabled } = @state

    t.div '.invitation-link-wrapper', =>
      if !linkEnabled
        t.button '.quiet-button', { onClick: @showLink }, ->
          t.format 'you-can-also-invite-people-by-giving-them-a-special-link'
      else
        t.format 'anyone-you-share-this-link-with-will-be-able-to-join'
        t.input {
          type: 'text'
          readOnly: true
          placeholder: t.l 'loading'
          ref: @inputDidMount
          value: invitationUrl
          onClick: @copyInvitationLink
        }
        t.button '.quiet-button', { onClick: @deactivateInvitationLink }, ->
          t.format 'disable-this-link'

  ############################################################################################################
  ############################################################################################################
  ############################################################################################################

  showLink: =>
    @setState linkEnabled: true

  inputDidMount: (input) =>
    if input
      { apiUrl, teamUrl } = @props

      ApiPromise
        method: 'post'
        url: "#{ apiUrl }/invitationSecret"
      .get 'secret'
      .then (secret) =>
        # Yes, this is gross … but eventually we won't be responsible for
        # forming these URLs anyway, since they should be coming from the server
        invitationUrl = teamUrl.replace ///
          (
            /b/[^/]+ # the /b/:shortlink portion of a board URL
            |
            /[^/]+$ # the /:orgname portion of an org URL
          )
          (.*)$
        ///, "/invite$1/#{ secret }$2"

        @setState { invitationUrl }
        input.focus()
      .done()

  deactivateInvitationLink: (e) =>
    { apiUrl } = @props

    @setState {
      invitationUrl: ''
      linkEnabled: false
    }

    ApiPromise
      method: 'delete'
      url: "#{ apiUrl }/invitationSecret"
    .done()

  copyInvitationLink: ({ target }) =>
    target.select()
    document.execCommand('copy')



// WEBPACK FOOTER //
// ./app/scripts/views/organization/manage-org-members-component/invitation-link.coffee